export const init = () => {

  const svg_e = document.querySelector(".home-video svg");
  if (!svg_e) return;

  gsap.to(svg_e, {
    scale: 32,
    transformOrigin: "42.2% center",
    ease: "none",
    force3D: true,

    scrollTrigger: {
      trigger: ".home-video",
      scrub: 1.5,
      pin: true,
      start: "center center",
      end: "+=1000",
      anticipatePin: 1,
      markers: false,
    },
  });
};
